import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles/styles.css';
import './styles/chat.css';
import './styles/artifact.css';
import './styles/run.css';
import './styles/auth.css';
import './styles/admin.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
